<form [formGroup]="contactForm">
  <div class="container">
    <div class="card p-4 mt-4 bg-image commonFormsCss splitbooking">
      <div class="row">
        <div class="col-sm-6">
          <h2 class="mt-3">Split Booking</h2>
        </div>
        <div class="col-sm-6 float-right p-2">
          <button role="button" (click)="splitBookingClose()" class="ba-btn ba-btn-sq-sm float-right"><i
              class="fa fa-times"></i></button>
        </div>
      </div>
      <div class="card mt-1 mb-4 p-3">
        <div class="row">
          <div class="col-sm-3 dotted-border">
            <h4>Existing Order</h4>
            <div *ngFor="let passenger of passengerDetailExistingOrder; let passengerIndex = index">{{
              passenger.passengerName }} {{ passenger.passengerSurName }}</div>
          </div>

          <div class="col-sm-7">
            <div class="ms-2">
              <i class="fa fa-cut fa-rotate-90 cuticon"></i>
            </div>
            <div class="ms-10">
              <h4>New Order</h4>
              <div class="ms-4" *ngFor="let passenger of passengerDetailNewOrder; let passengerIndex = index">{{
                passenger.passengerName }} {{ passenger.passengerSurName }}</div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-4 commonFormsCss">
            <div class="p-2 mt-4">
              <h4>Address</h4>
              <input type="text" id="address1" formControlName="address1" placeholder="address 1"
                class="form-control mt-2" [ngClass]="{ 'is-invalid': submitted && formControls['address1'].errors }" />
              <input type="text" id="address2" formControlName="address2" placeholder="address 2"
                class="form-control mt-2" [ngClass]="{ 'is-invalid': submitted && formControls['address2'].errors }" />
              <input type="text" id="city" formControlName="city" placeholder="city" class="form-control mt-2"
                [ngClass]="{ 'is-invalid': submitted && formControls['city'].errors }" />
              <input type="text" id="zip" formControlName="zip" placeholder="zip" class="form-control mt-2"
                [ngClass]="{ 'is-invalid': submitted && formControls['zip'].errors }" />
              <select id="countrycode" class="form-control mt-2 form-select" formControlName="countrycode"
                [ngClass]="{ 'is-invalid': submitted && formControls['countrycode'].errors }">
                <option value="" selected>(please select a country)</option>
                <option *ngFor="let country of countries" [value]="country.value">{{ country.name }}</option>
              </select>
              <input type="text" id="email" formControlName="email" placeholder="email@email.com"
                class="form-control mt-2" [ngClass]="{ 'is-invalid': submitted && formControls['email'].errors }" />
              <div class="mt-2">
                <ngx-intl-tel-input
                  [cssClass]="submitted && !contactForm.value.phone ? 'form-control is-invalid' : 'custom form-control'"
                  [preferredCountries]="preferredCountries" [enableAutoCountrySelect]="true" [enablePlaceholder]="true"
                  [searchCountryFlag]="true" [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]"
                  [selectFirstCountry]="false" [selectedCountryISO]="CountryISO.UnitedKingdom" [maxLength]="15"
                  [phoneValidation]="true" [separateDialCode]="separateDialCode"
                  [numberFormat]="PhoneNumberFormat.National" name="phone" formControlName="phone">
                </ngx-intl-tel-input>
              </div>
            </div>
            <button type="button" (click)="splitBooking()" class="btn btn-outline-primary m-2 p-3"><i
                class="fa fa-cut"></i> Split Booking</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>